import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';

const validateContactUs = ({ firstName, lastName, email, categoryId, subCategoryId, contactUsContent }) => {
  let errors = {};

  firstName = !isEmpty(firstName) ? firstName : '';
  lastName = !isEmpty(lastName) ? lastName : '';
  email = !isEmpty(email) ? email : '';
  categoryId = !isEmpty(categoryId) ? categoryId : '';
  subCategoryId = !isEmpty(subCategoryId) ? subCategoryId : '';
  contactUsContent = !isEmpty(contactUsContent) ? contactUsContent : '';

  if (Validator.isEmpty(firstName)) {

    errors.firstName = 'required';
  }

  if (Validator.isEmpty(lastName)) {

    errors.lastName = 'required';
  }

  if (Validator.isEmpty(email)) {

    errors.email = 'required';

  } else if (!Validator.isEmail(email)) {

    errors.email = 'email';
  }

  if (Validator.isEmpty(categoryId)) {

    errors.categoryId = 'required';
  }

  if (Validator.isEmpty(subCategoryId)) {

    errors.subCategoryId = 'required';
  }

  if (Validator.isEmpty(contactUsContent)) {

    errors.contactUsContent = 'required';
  }

  return {
    errors,
    isValid: isEmpty(errors)
  };
};

export default validateContactUs;
